import React, { memo } from 'react';
import SearchIcon from '../../assets/svg/Search.svg';
import BlogCategoryBar from './BlogCategoryBar';
import { motion } from 'framer-motion';

const BlogHeader = memo(({
    activeCategoryId,
    categories,
    handleChangeCategory,
    categoryLoader,
    onSearch,
    searchQuery
}) => {
    return (
        <div className="w-full mb-12">
            <div className="flex flex-col gap-8">
                {/* Hero Section */}
                <div className="relative overflow-hidden rounded-[32px] bg-gradient-to-br from-blue-600 via-indigo-700 to-violet-800 p-8 md:p-16 text-white shadow-2xl">
                    <div className="absolute top-0 right-0 -m-20 w-80 h-80 bg-white/10 rounded-full blur-3xl opacity-50" />
                    <div className="absolute bottom-0 left-0 -m-20 w-64 h-64 bg-blue-400/20 rounded-full blur-2xl opacity-30" />

                    <div className="relative z-10 max-w-2xl">
                        <motion.h1
                            initial={{ opacity: 0, x: -20 }}
                            animate={{ opacity: 1, x: 0 }}
                            className="text-2xl md:text-4xl font-black mb-6 tracking-tight leading-tight"
                        >
                            Explore Our <span className="text-blue-200">Stories</span> & Insights
                        </motion.h1>
                        <motion.p
                            initial={{ opacity: 0, x: -20 }}
                            animate={{ opacity: 1, x: 0 }}
                            transition={{ delay: 0.1 }}
                            className="text-md md:text-lg text-blue-100/90 leading-relaxed font-medium"
                        >
                            Discover the latest news, updates, and deep dives from the Language Village community.
                        </motion.p>
                    </div>

                    {/* Integrated Search Box */}
                    <motion.div
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ delay: 0.2 }}
                        className="mt-10 max-w-md"
                    >
                        <div className="relative group">
                            <div className="absolute inset-y-0 left-0 flex items-center pl-4 pointer-events-none">
                                <img
                                    className='w-5 h-5 opacity-60 group-focus-within:opacity-100 transition-opacity'
                                    src={SearchIcon}
                                    alt="Search"
                                />
                            </div>
                            <input
                                type="text"
                                className="w-full pl-12 pr-4 py-4 bg-white/10 backdrop-blur-md border border-white/20 rounded-2xl text-white placeholder-white/60 focus:outline-none focus:ring-2 focus:ring-white/30 focus:bg-white/20 transition-all shadow-lg"
                                placeholder="Search articles, topics..."
                                value={searchQuery}
                                onChange={(e) => onSearch(e.target.value)}
                            />
                        </div>
                    </motion.div>
                </div>

                {/* Categories Section */}
                <div className="flex flex-col gap-4">
                    <div className="flex items-center justify-between">
                        <h2 className="text-xl font-bold text-gray-900 px-1">Browse Categories</h2>
                    </div>
                    <BlogCategoryBar
                        categories={categories}
                        activeCategoryId={activeCategoryId}
                        onSelectCategory={handleChangeCategory}
                        loading={categoryLoader}
                    />
                </div>
            </div>
        </div>
    );
});

export default BlogHeader;